"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PlurallEnvironment = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _graphql = _interopRequireDefault(require("./clients/graphql"));
var _rest = _interopRequireDefault(require("./clients/rest"));
var _applications = _interopRequireDefault(require("./endpoints/applications"));
var _dashboard = _interopRequireDefault(require("./endpoints/dashboard"));
var _menu = _interopRequireDefault(require("./endpoints/menu"));
var _profile = _interopRequireDefault(require("./endpoints/profile"));
var _utils = require("./utils");
var PlurallClient = /*#__PURE__*/function () {
  function PlurallClient(config) {
    var _this = this;
    (0, _classCallCheck2.default)(this, PlurallClient);
    (0, _defineProperty2.default)(this, "graphqlClient", void 0);
    (0, _defineProperty2.default)(this, "restClient", void 0);
    (0, _defineProperty2.default)(this, "config", void 0);
    /**
     * Retorna o access token atual do usuário. Leva em consideraçao o `environment` passado na inicializaçao do client.
     */
    (0, _defineProperty2.default)(this, "getAccessToken", function () {
      var isProduction = _this.config.environment === 'production';
      var cookieName = isProduction ? 'shared_cookie' : "".concat(_this.config.environment, "_shared_cookie");
      return PlurallClient.getCookieByName("\\b".concat(cookieName, "=([^;]*)\\b"));
    });
    /**
     * Retorna o session id atual do usuário.
     */
    // eslint-disable-next-line class-methods-use-this
    (0, _defineProperty2.default)(this, "getSessionId", function () {
      return PlurallClient.getCookieByName("\\b_pid=([^;]*)\\b");
    });
    (0, _defineProperty2.default)(this, "getOrCreateSessionId", function () {
      if (typeof document === 'undefined') {
        return undefined;
      }
      var sessionId = _this.getSessionId();
      if (sessionId) {
        return sessionId;
      }
      var plurallSessionID = PlurallClient.generateUuid();
      document.cookie = "_pid=".concat(plurallSessionID, "; path=/; Max-Age=31536000; domain=.plurall.net");
      return plurallSessionID;
    });
    (0, _utils.validateConfig)(config, 'apiURL');
    (0, _utils.validateConfig)(config, 'graphqlURL');
    this.restClient = new _rest.default(config, {
      clientId: this.getOrCreateSessionId()
    });
    this.graphqlClient = (0, _graphql.default)(config, {
      clientId: this.getOrCreateSessionId()
    });
    this.config = config;
  }
  (0, _createClass2.default)(PlurallClient, [{
    key: "dashboard",
    get: function get() {
      return (0, _dashboard.default)(this);
    }
  }, {
    key: "profile",
    get: function get() {
      return (0, _profile.default)(this);
    }
  }, {
    key: "menu",
    get: function get() {
      return (0, _menu.default)(this);
    }
  }, {
    key: "applications",
    get: function get() {
      return (0, _applications.default)(this);
    }
  }]);
  return PlurallClient;
}();
(0, _defineProperty2.default)(PlurallClient, "getCookieByName", function (name) {
  if (typeof document === 'undefined') {
    return undefined;
  }
  var match = document.cookie.match(name);
  return match ? match[1] : undefined;
});
(0, _defineProperty2.default)(PlurallClient, "generateUuid", function () {
  // eslint-disable-next-line func-names
  return "PLTR.xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx.".concat(new Date().getTime()).replace(/[xy]/g, function (c) {
    // eslint-disable-next-line no-bitwise
    var r = Math.random() * 16 | 0;
    // eslint-disable-next-line no-bitwise
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
});
// eslint-disable-next-line no-shadow
var PlurallEnvironment = /*#__PURE__*/function (PlurallEnvironment) {
  PlurallEnvironment["Development"] = "development";
  PlurallEnvironment["Staging"] = "staging";
  PlurallEnvironment["PullRequest"] = "pull_request";
  PlurallEnvironment["Production"] = "production";
  return PlurallEnvironment;
}({});
exports.PlurallEnvironment = PlurallEnvironment;
var _default = PlurallClient;
exports.default = _default;